export default "__VITE_ASSET__BKAMe1k5__"